/**
 * Splash — wordless system-entry transition.
 *
 * Visual design = existing /public/_splash_preview.html (do NOT diverge from it).
 * Gradient, logo asset, and fade-in animation are ALL copied verbatim from that file.
 *
 * Rules (product spec):
 *   • Full screen, centered logo only. No text. No interaction.
 *   • Duration ~1000ms (800–1200ms range).
 *   • Smooth fade. No hard cut, no delay after.
 *   • Used ONLY after successful signup or login.
 */
import React, { useEffect } from 'react';
import GlowingReLogo from './GlowingReLogo';

const Splash = ({ onComplete, duration = 1000 }) => {
  useEffect(() => {
    if (!onComplete) return undefined;
    const t = setTimeout(onComplete, duration);
    return () => clearTimeout(t);
  }, [onComplete, duration]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
      style={{
        background:
          'linear-gradient(135deg, #020617 0%, #172554 15%, #f1f5f9 40%, #ffffff 65%, #eff6ff 100%)',
      }}
      data-testid="splash"
      aria-hidden="true"
    >
      <div style={{ animation: 'splashLogoIn 0.5s cubic-bezier(0.16,1,0.3,1) forwards' }}>
        <GlowingReLogo size={96} variant="blue" testId="splash-logo" />
      </div>
      <style>{`
        @keyframes splashLogoIn {
          0%   { opacity: 0; transform: scale(0.95); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default Splash;
